<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '练习1',
        small: [
          {
            id: 1,
            title: '(1)',
            durationTime: 100,
            steer: [
              {
                id: '1-1',
                buttonStyle: {
                  width: '95%'
                },
                middenText: {
                  style: {
                    width: '45%',
                    top: '260px',
                    left: '27.5%',
                    bg: require('@/assets/exam/bj_iyindao.png')
                  },
                  value: [
                    { text: '同学，你好！' },
                    { text: '以下是正式测评开始前的练习，请你通过练习熟悉正式测评中将要用到的计算机操作。' },
                    { text: '练习由一些简单的问题组成，老师不会对你的作答判分，就是说无论你如何作答都不会影响你的正式测评结果。请认真熟悉每一种计算机操作，如果有问题，随时举手询问。' }
                  ]
                }
              },
              {
                id: '1-2',
                imgbgModelSteer: true,
                rightModelSteer: true,
                rightbgType: 'left',
                bgImg: require('@/assets/exam/mc_x.png'),
                rightbg: require('@/assets/exam/bj_kuang_yi.png'),
                buttonStyle: {
                  width: '55%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    top: '20%',
                    left: '4%',
                    width: '45%'
                  },
                  value: [
                    { text: '1.本次测试可以通过“键盘录入”“语音录入”两种方式录入文字。语音录入后，可以再通过键盘录入编辑修改。' },
                    // { img: require('@/assets/exam/dianji.png') },
                    // { text: '”' },
                    // { text: '两种方式录入文字。语音录入后，可以在通过键盘编辑修改。 ' }
                  ]
                },
                // bg: [
                //   {
                //     img: require('@/assets/exam/bj_kuang_yi.png'),
                //     style: {
                //       top: '35.5%',
                //       left: '48.5%',
                //       width: '52%',
                //       height: '4.5rem'
                //     }
                //   }
                // ],
              },
              {
                id: '1-3',
                imgbgModelSteer: true,
                rightModelSteer: true,
                rightbgType: 'left',
                rightbg: require('@/assets/exam/bj_kuang_yi.png'),
                buttonStyle: {
                  width: '55%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    top: '20%',
                    // left: '4%',
                    width: '50%'
                  },
                  value: [
                    { text: '2.语音录入操作方式：按住 “' },
                    { img: require('@/assets/exam/changan.png') },
                    { text: '”' },
                    { text: '按钮（不要松开），' },
                    { text: '说出你的答案。可多次点击录入。请注意，语音录入有延时，看到你说出的文字完整显示后，再松开“按住录入”按钮。' }
                  ]
                },
                // bg: [
                //   {
                //     img: require('@/assets/exam/bj_kuang_yi.png'),
                //     style: {
                //       top: '35.5%',
                //       left: '48.5%',
                //       width: '52%',
                //       height: '340px'
                //     }
                //   },
                //   {
                //     img: require('@/assets/exam/button_kuang.png'),
                //     style: {
                //       top: '57.6%',
                //       left: '57%',
                //       width: '160px',
                //     }
                //   },
                //   // {
                //   //   img: require('@/assets/exam/mc_x.png'),
                //   //   style: {
                //   //     top: '39.5%',
                //   //     left: '56.5%',
                //   //     width: '42%',
                //   //     height: '260px',
                //   //   }
                //   // }
                // ],
              },
              {
                id: '1-4',
                rightModelSteer: true,
                rightbgType: 'left',
                buttonStyle: {
                  width: '55%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    top: '20%',
                    left: '5%',
                    width: '45%'
                  },
                  value: [
                    { text: '3.键盘录入操作方式：点击作答区并开始键盘录入。' }
                  ]
                },
                rightbg: require('@/assets/exam/bj_kuang_yi.png'),
                // bg: [
                //   {
                //     img: require('@/assets/exam/bj_kuang_yi.png'),
                //     style: {
                //       top: '35.5%',
                //       left: '48.5%',
                //       width: '52%',
                //       height: '340px'
                //     }
                //   }
                // ],
              }
            ],
            desc: [
              '本次测试可以通过“键盘录入”“语音录入”两种方式录入文字。语音录入后，可以再通过键盘录入编辑修改。',
              '语音录入操作方式：按住“按住录入”按钮（不要松开），说出你的答案。可多次点击录入。请注意，语音录入有延时，看到你说出的文字完整显示后，再松开“按住录入”按钮。',
              '键盘录入操作方式：点击作答区并开始键盘录入。'
            ],
            stemContent: [
              {
                type: 'text',
                value: '<b>练习1：</b>请将下面一段文字，录入在右侧作答区：'
              },
              {
                type: 'text',
                value: '我每天骑自行车上学。'
              },
              {
                type: 'text',
                value: '我周末骑自行车郊游。'
              },
              {
                type: 'text',
                value: '我有时候会看山地自行车赛事转播。'
              }
              // {
              //   type: 'text',
              //   value: '我父亲的那辆自行车是六十年代出产的永久牌。从我记事到八十年代离家求学，我父亲一直骑着它早出晚归。——摘自《自行车之歌》，苏童著'
              // }
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
            }]
          },
          {
            id: 2,
            title: '(2)',
            steer: [
              {
                id: '2-1',
                rightModelSteer: true,
                buttonStyle: {
                  width: '50%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    // top: '10%',
                    left: '-4%',
                    width: '55%'
                  },
                  value: [
                    { text: '这个练习是为了使你熟悉通过连续多次点击“' },
                    { img: require('@/assets/exam/dianji.png') },
                    { text: '”或“' },
                    { img: require('@/assets/exam/changan.png') },
                    { text: '”按钮录' },
                    { text: '入多个答案。' },
                    { text: '<div style="width: 800px; font-size: 0.21333rem;">使用键盘录入的具体操作是：</div>' },
                    { text: '<li>点击“文字录入”按钮，出现第1个作答文本框，使用键盘录入你对这个问题的第1个答案；</li>' },
                    { text: '<li>再次点击“文字录入”按钮，出现第2个作答文本框，使用键盘录入你对这个问题的第2个答案；</li>' },
                    { text: '<li>重复以上操作直到写完你的所有答案。</li>' },
                    { text: '<div style="width: 800px; font-size: 0.21333rem;">使用语音录入的具体操作是：</div>' },
                    { text: '<li>点击“按住录入”按钮后按住，同时说出你对这个问题的第1个答案，说完后松开按钮；</li>' },
                    { text: '<li>再次点击“按住录入”按钮后按住，同时说出你对这个问题的第2个答案，说完后松开按钮；</li>' },
                    { text: '<li>依次操作直到说完你的所有答案</li>' },
                    { text: '请注意，语音录入有延时，看到你说出的文字完整显示后，再松开“按住录入”按钮。你说出的答案会显示在作答区，如果有需要，你可以点击相应的答案，通过键盘录入进行修改。' }
                  ]
                },
                // bg: [
                //   {
                //     img: require('@/assets/exam/button_kuang.png'),
                //     style: {
                //       top: '35.2%',
                //       left: '55.9%',
                //       width: '150px'
                //     }
                //   }
                // ],
              }
            ],
            desc: [
              '这个练习是为了使你熟悉通过连续多次点击“<img style="height: 36px; top: 10px; position: relative" src="' + require('@/assets/exam/dianji1.png') + '"/>”或“<img style="height: 36px; top: 10px; position: relative" src="' + require('@/assets/exam/changan.png') + '"/>”按钮录入多个答案。',
              '使用键盘录入的具体操作是：',
              '<li>点击“文字录入”按钮，出现第1个作答文本框，使用键盘录入你对这个问题的第1个答案；</li>',
              '<li>再次点击“文字录入”按钮，出现第2个作答文本框，使用键盘录入你对这个问题的第2个答案；</li>',
              '<li>重复以上操作直到写完你的所有答案。</li>',
              '使用语音录入的具体操作是：',
              '<li>点击“按住录入”按钮后按住，同时说出你对这个问题的第1个答案，说完后松开按钮；</li>',
              '<li>再次点击“按住录入”按钮后按住，同时说出你对这个问题的第2个答案，说完后松开按钮；</li>',
              '<li>依次操作直到说完你的所有答案</li>',
              '请注意，语音录入有延时，看到你说出的文字完整显示后，再松开“按住录入”按钮。你说出的答案会显示在作答区，如果有需要，你可以点击相应的答案，通过键盘录入进行修改。'
            ],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '<b>练习2：</b>请观察下图中的自行车，尽可能多的说出自行车的不同零部件，如：刹车线。'
              },
              {
                type: 'img',
                value: require('@/assets/exam/42.png')
              },
            ],
            askList: [{
              id: 1,
              type: 4,
              config: {
                noneInput: true,
                type: 1
              }
            }]
          }
        ]
      }, {
        qid: 2,
        title: '练习2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 100,
            steer: [
              {
                id: '3-1',
                rightModelSteer: true,
                leftModelSteer: true,
                leftbg: [
                  require('@/assets/exam/kuang_left.png'),
                  require('@/assets/exam/kuang_jian.png'),
                  require('@/assets/exam/yidong.png')
                ],
                buttonStyle: {
                  width: '70%',
                  float: 'right'
                },
                leftText: {
                  style: {
                    top: '22%',
                    left: '45%',
                    width: '40%'
                  },
                  value: [
                    { text: '1.这个练习是为了使你熟悉“拖拽”“录入”“增加分类框”这三种操作。拖拽的具体操作是点击并按住左侧的某一个答案，同时滑动鼠标至目标位置，然后松开鼠标。' }
                  ],
                }
              },
              {
                id: '3-2',
                imgbgModelSteer: true,
                rightModelSteer: true,
                buttonStyle: {
                  width: '10%',
                  float: 'left',
                  algin: 'right',
                  top: '-40px',
                  padding: 0
                },
                leftText: {
                  style: {
                    top: '13%',
                    left: '-14%',
                    width: '33%'
                  },
                  value: [
                    { text: '2.录入的具体操作有两种，分别是“键盘录入”“语音录入”，你在前两个练习中已经了解。请在本练习中再次熟悉这两种方式。' },
                  ]
                },
                rightbg: require('@/assets/exam/kuang_right_chang.png')
              },
              {
                id: '3-3',
                rightModelSteer: true,
                buttonStyle: {
                  width: '55%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    top: '18%',
                    left: '60px',
                    width: '45%'
                  },
                  value: [
                    { text: '3.“增加分类框”的具体操作是，点击相应位置的 “' },
                    { img: require('@/assets/exam/icon_tian.png') },
                    { text: ' ”' },
                    { text: ', 点击后你将看到新增的分类框。' }
                  ]
                }
              }
            ],
            desc: [
              '这个练习是为了使你熟悉“拖拽”“录入”“增加分类框”这三种操作。',
              '拖拽的具体操作是：点击并按住左侧的某一个答案，同时滑动鼠标至目标位置，然后松开鼠标。',
              '录入的具体操作有两种，分别是：“键盘录入”“语音录入”，你在前两个练习中已经了解。请在本练习中再次熟悉这两种方式。',
              '增加分类框的具体操作是：点击相应位置的“+”，点击后你将看到新增的分类框。'
            ],
            stemContent: [
              {
                type: 'text',
                value: '<b>练习3：</b>请将你写出的零部件按功能拖拽到右侧的分类框中。点击“＋”可以添加新的分类框。'
              },
              {
                type: 'text',
                value: '如果你写出的零部件不属于任何分类框，请你首先自己增加一个分类框，并给这个类别命名，然后再将零部件名称拖拽其中；'
              },
              {
                type: 'text',
                value: '如果看了右侧的分类框，你又想起了一些之前没有写出的零部件，请你直接在分类框中写出它的名称。'
              },
              {
                type: 'array'
              }
            ],
            askList: [{
              id: 1,
              type: 8,
              value: '类别',
              typeList: [
                {
                  title: '转向装置',
                  disabled: true,
                  children: []
                },
                {
                  title: '动力装置',
                  disabled: true,
                  children: []
                }
              ]
            }]
          },
          {
            id: 4,
            title: '(4)',
            durationTime: 100,
            steer: [
              {
                id: '4-1',
                rightModelButtonSteer: true,
                buttonStyle: {
                  width: '45%',
                  float: 'left',
                  algin: 'right',
                  top: '-50px'
                },
                leftText: {
                  style: {
                    top: '31.5%',
                    // left: '120px',
                    width: '45%',
                    algin: 'left'
                  },
                  value: [
                    { text: '1.右侧有两张自行车图片，其中一辆没有车筐；另一辆没有后座椅。请你选择其中一辆，为它增加车筐或者后座椅。 ' }
                  ]
                },
                bg: [
                  {
                    img: require('@/assets/exam/kuang_up.png'),
                    style: {
                      top: '15%',
                      left: '8%',
                      height: '58%',
                      width: '45%'
                    }
                  },
                  {
                    img: require('@/assets/exam/43_button.png'),
                    style: {
                      top: '19%',
                      left: '10%',
                      width: '20%',
                    }
                  },
                  {
                    img: require('@/assets/exam/44_button.png'),
                    style: {
                      top: '19%',
                      left: '31%',
                      width: '20%',
                    }
                  }
                ],
              },
              {
                id: '4-2',
                rightModelSteer: true,
                buttonStyle: {
                  width: '55%',
                  float: 'left'
                },
                leftText: {
                  style: {
                    top: '300px',
                    // left: '100px',
                    width: '45%'
                  },
                  value: [
                    { text: '2.用简单的图画示意车筐或者后座椅的安装位置和形状，并在旁边用文字标识出“车筐”或“后座椅”。' }
                  ]
                },
              }
            ],
            desc: [''],
            stemContent: [
              {
                type: 'text',
                value: '<b>练习4：</b>右侧有两张自行车图片，其中一辆没有车筐；另一辆没有后座椅。请你选择其中一辆，为它增加车筐或者后座椅。用简单的图画示意车筐或者后座椅的安装位置和形状，并在旁边用文字标识出“车筐”或“后座椅”。'
              },
              {
                type: 'text',
                value: '这个练习是为了使你熟悉用鼠标在绘图区绘出简要示意图，并在需要的情况下添加文字说明。'
              }
            ],
            askList: [{
              id: 1,
              type: 10,
              value: 'draw',
              drawImg: [
                { name: '无车筐', url: require('@/assets/exam/43.png') },
                { name: '无后座椅', url: require('@/assets/exam/44.png') }
              ],
              title: '画图区：'
            }]
          },
        ]
      }, {
        qid: 3,
        title: '练习3',
        small: [
          {
            id: 5,
            title: '(5)',
            steer: [
              {
                id: '5-1',
                leftModelSteer: true,
                imgModelSteer: true,
                leftbg: require('@/assets/exam/kuang_left.png'),
                buttonStyle: {
                  width: '48%',
                  float: 'right',
                  algin: 'center'
                },
                leftText: {
                  style: {
                    top: '15%',
                    left: '60%',
                    width: '30%',
                    algin: 'left'
                  },
                  value: [
                    { text: '1.点击图片中的“小旗子”可以出现新的内容。请点击左侧图中的小旗子，看看这些零部件的命名吧。 ' }
                  ]
                },
                bg: [
                  {
                    img: require('@/assets/exam/kuang_jian.png'),
                    style: {
                      top: '43%',
                      left: '54%',
                      width: '250px'
                    }
                  }
                ],
              },
              {
                id: '5-2',
                leftModelSteer: true,
                imgModelSteer: true,
                leftbg: require('@/assets/exam/kuang_left.png'),
                buttonStyle: {
                  width: '48%',
                  float: 'right',
                  algin: 'center'
                },
                leftText: {
                  style: {
                    top: '15%',
                    left: '60%',
                    width: '30%',
                    algin: 'left'
                  },
                  value: [
                    { text: '2.在稍后的正式任务中，点击小旗子后可能出现的是一段视频或图画。 ' }
                  ]
                },
                bg: [
                  {
                    img: require('@/assets/exam/kuang_jian.png'),
                    style: {
                      top: '41%',
                      left: '54%',
                      width: '250px'
                    }
                  }
                ],
              }
            ],
            stemContent: [
              {
                type: 'text',
                value: '<b>练习5：</b>下面我们来看看图中这辆自行车的零部件是否和你写出的一致'
              },
              // {
              //   type: 'text',
              //   value: '这个练习是为了使你熟悉用鼠标在绘图区绘出简要示意图。'
              // },
              {
                type: 'innovation',
                value: require('@/assets/exam/42.png'),
                imgArr: [
                  {
                    x: '32%',
                    y: '6%',
                    lineTop: '-40%',
                    lineLeft: '-80%',
                    textTop: '20%',
                    textLeft: '-190%',
                    transform: 270,
                    name: '坐垫',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xuesheng.mp4'
                  },
                  {
                    x: '30%',
                    y: '35%',
                    lineTop: '-170%',
                    lineLeft: '102%',
                    textTop: '-260%',
                    textLeft: '150%',
                    transform: 50,
                    name: '刹车线',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/daolu.mp4'
                  },
                  {
                    x: '35%',
                    y: '72%',
                    lineTop: '-50%',
                    lineLeft: '110%',
                    textTop: '50%',
                    textLeft: '170%',
                    transform: -80,
                    name: '链条',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xiaohu.mp4'
                  },
                  {
                    x: '15%',
                    y: '69%',
                    lineTop: '15%',
                    lineLeft: '0%',
                    textTop: '240%',
                    textLeft: '-100%',
                    transform: 50,
                    name: '后变速器',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/xiaohu.mp4'
                  },
                  {
                    x: '71%',
                    y: '41%',
                    lineTop: '-170%',
                    lineLeft: '102%',
                    textTop: '-260%',
                    textLeft: '150%',
                    transform: 50,
                    name: '辐条',
                    icon: require('@/assets/exam/qizi_icon@2x.png'),
                    videoUrl: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/daolu.mp4'
                  }
                ]
              }
            ],
            durationTime: 100,
            desc: [
              '这个练习是为了使你知道，点击图片中的“小旗子”可以出现新的内容。请点击左侧图中的小旗子，看看这些零部件的命名吧。',
              '在稍后的正式任务中，点击小旗子后可能出现的是一段视频或图画。'
            ],
            askList: [],
          },
          {
            id: 6,
            title: '(6)',
            steer: [
              {
                id: '6-1',
                leftModelSteer: true,
                buttonStyle: {
                  width: '45%',
                  float: 'left',
                  algin: 'center',
                  top: '-40px'
                },
                leftText: {
                  style: {
                    top: '31%',
                    left: '20px',
                    width: '42%',
                    algin: 'left'
                  },
                  value: [
                    { text: '1.这个练习为了使你熟悉如何改变给出的图形，并拖拽到相应位置。具体的操作是，鼠标放在图形上点击右键，根据提示对形状、颜色进行选择实现修改。 ' }
                  ]
                }
              },
              {
                id: '6-2',
                leftModelSteer: true,
                buttonStyle: {
                  width: '50%',
                  float: 'left',
                  algin: 'center',
                  top: '-40px'
                },
                leftText: {
                  style: {
                    top: '31%',
                    left: '20px',
                    width: '42%',
                    algin: 'left'
                  },
                  value: [
                    { text: '2.这个练习只需要进行形状、颜色的改动，后面的正式测试中，你可以在给定的调整方式上做出任何你想要的改动。 ' }
                  ]
                }
              }
            ],
            stemContent: [
              {
                type: 'text',
                value: '<b>练习6：</b>右侧的自行车缺少一个车灯，请你调整给出的图形工具，为自行车制作一个圆形、黄色且大小适度的灯泡示意图，并拖拽到图中虚线框指定的位置。'
              },
              {
                type: 'img',
                value: require('@/assets/exam/42.png')
              }
            ],
            showAnswer: true,
            durationTime: 100,
            desc: [
              '这个练习为了使你熟悉如何改变给出的图形，并拖拽到相应位置。',
              '具体的操作是：鼠标放在图形上点击右键，根据提示对形状、颜色进行选择实现修改。',
              '这个练习只需要进行形状、颜色的改动，后面的正式测试中，你可以在给定的调整方式上做出任何你想要的改动。'
            ],
            askList: [{
              id: 1,
              type: 9,
              customList: [
                { left: 0, top: 0, title: '' }]
            }],
          }
        ]
      }],
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getAnswer(obj) {
      this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const examArr = JSON.parse(sessionStorage.currentExamGroup || '[]').exam || []
      const isEnd = type === 'overTime' || (examArr.length === 1 && currentQSmall === 6) // 超时或者只有一个试卷的最后一题，结束考试
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 11,
        subject_name: '创新引导',
        pic_info: '答案',
        status: isEnd ? 1 : 2
      }, sonData)
      const res = await answerUpload(data)
      this.loading = false
      if (!res || res.code != '200') {
        this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
        return
      }
      if (type === 'overTime' || currentQSmall === 6) {
        this.nextPage(isEnd)
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: sessionStorage.subjectName,
              isEnd: true
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
